export const isAutotestUserAgent = (userAgent: string) => {
    return /auto-?test/.test(userAgent);
};
